export default {
  mounted(el, binding) {
    const text = binding.value;
    let tooltip = document.createElement("div");
    tooltip.textContent = text;
      tooltip.style.position = "absolute";
      tooltip.style.backgroundColor = "#333";
      tooltip.style.color = "#fff";
      tooltip.style.padding = "5px 8px";
      tooltip.style.borderRadius = "4px";
      tooltip.style.top = "100%";
      tooltip.style.left = "50%";
      tooltip.style.transform = "translateX(-50%)";
      tooltip.style.whiteSpace = "nowrap";
      tooltip.style.zIndex = "1000";
      tooltip.style.display = "none";

    if (text.length > 12) {
      el.textContent = `${text.slice(0, 12)}...`;
      el.style.cursor = "pointer";

      el.style.position = "relative";
      el.appendChild(tooltip);

      // Show/hide tooltip on hover
      el.addEventListener("mouseenter", () => {
        tooltip.style.display = "block";
      });
      el.addEventListener("mouseleave", () => {
        tooltip.style.display = "none";
      });

      // ✅ Double-click to copy
      el.addEventListener("dblclick", () => {
        navigator.clipboard.writeText(text).then(() => {
          tooltip.textContent = "Copied!";
          tooltip.style.display = "block";

          setTimeout(() => {
            tooltip.textContent = text; // restore original
            tooltip.style.display = "none";
          }, 1200);
        });
      });
    } else {
      el.textContent = text;
      el.style.cursor = "default";

      el.addEventListener("dblclick", () => {
        navigator.clipboard.writeText(text).then(() => {
          tooltip.textContent = "Copied!";
          tooltip.style.display = "block";

          setTimeout(() => {
            tooltip.textContent = text; // restore original
            tooltip.style.display = "none";
          }, 1200);
        });
      });
    }
  }
};
